import { Box, InputBase, useTheme } from "@mui/material"
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ShPayloadToggle from "../../theme/ShPayloadToggle";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAddWarehouseLocationMutation } from "../../../newapi/warehouse/warehouselocationSlice";
import { useCreateShipmentLabelMutation } from "../../../newapi/order/ordersSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedInputDropdown from "../../theme/dropdowns/ShValidatedInputDropdown";
import { yupRequired, yupNumberRequired } from "../../../utils/validation";
import { useGetWarehouseLocationTypesSelectQuery } from "../../../newapi/warehouse/warehouseLocationTypeSlice";
import { useGetReachTypesSelectQuery } from "../../../newapi/warehouse/reachTypeSlice";
import { useGetWarehouseLevelsSelectQuery, useGetWarehouseZonesSelectQuery, useGetWarehousesSelectQuery } from "../../../newapi/warehouse/warehouseApiSlice";
import { useGetShippersSelectWithProfilesQuery } from '../../../newapi/shipper/shipperSlice';
import { useAddShipmentMutation } from "../../../newapi/global/echeckSlice";

const MAddShipment = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    

    const [selected, setSelected] = useState(-1);

    const select = (selected) => {
        setSelected(selected);
    }
    
    const { data: shippers, isLoading: shippersLoading,isFetching: shippersFetching,isError: shippersError } = useGetShippersSelectWithProfilesQuery({ warehouseId: props.data?.warehouseId },
        {
            skip: !props.data?.warehouseId
        });

    const [shipmentInfo, setShipmentInfo] = useState({
        shipperId: 0,
        shipperProfileId: 0
    });

    const [shipperProfiles, setShipperProfiles] = useState([]);

    useEffect(() => {
        if (props.open) {
            setShipmentInfo({
                id: props.data?.id, // Order ID
                shipperId: props.data?.shipperId,
                shipperProfileId: props.data?.shipperProfileId
            });

            const shipper = shippers?.find(shipper => shipper.id === props.data?.shipperId);
            setShipperProfiles(shipper?.shipperProfiles ?? []);
        }
    }, [props.open]);
    const [fieldErrors, setFieldErrors] = useState({});
    const [shippingErrors,setShippingErrors] = useState([]);
    const [shippingPayload, setShippingPayload] = useState(null);

    const rules = {
        shipperId: yupRequired('shipper', t),
        shipperProfileId: yupNumberRequired('shipper_profile', t)
    };
    
    const schema = yup.object().shape(rules);

    const handleClose = () => {
        setShipmentInfo({
            id: 0,
            shipperId: 0,
            shipperProfileId: 0
        });

        props.handleClose();
    }

    const [createShipmentLabel,{isLoading: isCreateShipmentLabelLoading}] = useCreateShipmentLabelMutation();
    const SaveShipment = async () => {
        try {
            if (isCreateShipmentLabelLoading) return;

            const createObject = {
                id:shipmentInfo.id,
                shipperId:shipmentInfo.shipperId,
                shipperProfileId:shipmentInfo.shipperProfileId,
                workspaceId:selectedWorkSpace.id,
            };

            setFieldErrors({});
            await schema.validate(createObject, { abortEarly: false });

            const data = await createShipmentLabel(createObject).unwrap();
            showToastMessagePostRequest(t, data);
            setShippingErrors(null);
            setShippingPayload(null);

            handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                    ...acc,
                    [currentError.path]: currentError.message
                }), {});
            
                // Set the validation errors in the state
                setFieldErrors(errors);
            } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
                setShippingErrors(err.data?.errors);
                setShippingPayload(err?.data?.payload ?? null);
            }
        }
    }
   
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const selectShipper = (key, value) => {
        var shipper = shippers?.find(shipper => shipper.id === value);
        setShipmentInfo(prev => ({
            ...prev,
            shipperId: shipper.id,
            shipperProfileId: -1
        }));

        setShipperProfiles(shipper?.shipperProfiles ?? []);
    }

    const selectShipperProfile = (key, value) => {
        var shipperProfile = shipperProfiles.find(profile => profile.id === value);
        setShipmentInfo(prev => ({
            ...prev,
            shipperProfileId: shipperProfile.id
        }));
    }

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("new_shipment")}</Subheading>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >


                    <Box
                        sx={{
                            width:120,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("shipper")}</Text>
                    </Box>
                    <ShValidatedInputDropdown
                        key={shipmentInfo.shipperId}
                        selected={shippers?.findIndex(item => item.id === shipmentInfo.shipperId) ?? -1}
                        name="shipperId"
                        displayName="name"
                        changeField="id"
                        options={shippers ?? []}
                        noSelection={t("choose_option")} 
                        onChange={selectShipper}
                        error={fieldErrors.shipperId}
                    />
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("shipper_profile")}</Text>
                    </Box>
                    <ShValidatedInputDropdown
                        key={shipmentInfo.shipperProfileId}
                        selected={shipperProfiles?.findIndex(item => item.id === shipmentInfo.shipperProfileId) ?? -1}
                        name="shipperProfileId"
                        displayName="name"
                        changeField="id"
                        options={shipperProfiles ?? []}
                        noSelection={t("choose_option")} 
                        onChange={selectShipperProfile}
                        error={fieldErrors.shipperProfileId}
                    />
                </Box>
                {shippingErrors && shippingErrors.length > 0 &&
                    <Box 
                        sx={{
                            // position:"absolute",
                            // right:16,
                            // bottom:80,
                            minWidth:300,
                            maxHeight:250,
                            overflow:"auto",
                            background:colors.red[100],
                            borderRadius:3,
                            p:2,
                            display:"flex",
                            flexDirection:"column",
                            gap:1,
                            pr:8,
                            maxWidth:500,
                        }}
                    >
                        {shippingErrors.map((err,idx) => (
                            <Text key={"se"+idx} bold variant={"red"}>{err}</Text>
                        ))}
                        <ShPayloadToggle payload={shippingPayload} />
                    </Box>
                }
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isCreateShipmentLabelLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveShipment()}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddShipment;
